import { render, staticRenderFns } from "./ModalLimitQuota.vue?vue&type=template&id=bc018cdc&scoped=true&"
import script from "./ModalLimitQuota.vue?vue&type=script&lang=js&"
export * from "./ModalLimitQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc018cdc",
  null
  
)

export default component.exports